import { render, staticRenderFns } from "./CommunicationRulesItem.vue?vue&type=template&id=b0367a2e&scoped=true&"
import script from "./CommunicationRulesItem.vue?vue&type=script&lang=js&"
export * from "./CommunicationRulesItem.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationRulesItem.vue?vue&type=style&index=0&id=b0367a2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0367a2e",
  null
  
)

export default component.exports